<template>
  <div class="col-12 p-0">

<div class="row">
  <dashboard-header-widget class="col-lg-12 col-md-12 "/>
</div>
    <div class="row mt-n5">


      <div class="col-lg-3  my-3">
        <m-a :href="{name:'User'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">کاربران</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="person"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['user'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'CreateUser'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'ProductsDashboard'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">محصولات</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="box"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['products'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'CreateProduct'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <dashboard-slider1 class="radius-15 bg-secondary" slug="بنر-داشبورد-1"/>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Brand'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">برندها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="lightbulb"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['brand'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'CreateBrand'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-6 my-3">
        <dashboard-slider1 class="radius-15 bg-secondary" slug="بنر-داشبورد-2"/>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Category'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">دسته ها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="tags"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['category'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'Category'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'CoursesDashboard'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">دوره ها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="journal"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['course'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'CreateCourse'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>

      <div class="col-lg-3 my-3">
        <m-a :href="{name:'LessonsDashboard'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">درس ها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="book-half"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['lesson'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'CreateLessons'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Orders'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">سفارشات</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="credit-card-fill"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['order'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'CreateOrder'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'FileManager'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15 h-100">
            <div class="row">
              <div class="col-6">
                <div class="row">
                  <div class="col-12 text-right">
                    <h4 class="p-0 m-0">مدیریت فایل</h4>
                  </div>

                  <div class="col-12 text-right mt-3">
                    <h4 v-if="!loading" class="p-0 m-0">{{ items['files'] }}</h4>
                    <div class="" v-else>
                      <div class="loader"></div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-6">
                <div class="col-12 p-0 text-left">

                  <button class="Documents-btn bg-transparent">
  <span class="folderContainer">
    <svg
        class="fileBack"
        width="146"
        height="113"
        viewBox="0 0 146 113"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
      <path
          d="M0 4C0 1.79086 1.79086 0 4 0H50.3802C51.8285 0 53.2056 0.627965 54.1553 1.72142L64.3303 13.4371C65.2799 14.5306 66.657 15.1585 68.1053 15.1585H141.509C143.718 15.1585 145.509 16.9494 145.509 19.1585V109C145.509 111.209 143.718 113 141.509 113H3.99999C1.79085 113 0 111.209 0 109V4Z"
          fill="url(#paint0_linear_117_4)"
      ></path>
      <defs>
        <linearGradient
            id="paint0_linear_117_4"
            x1="0"
            y1="0"
            x2="72.93"
            y2="95.4804"
            gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8F88C2"></stop>
          <stop offset="1" stop-color="#5C52A2"></stop>
        </linearGradient>
      </defs>
    </svg>
    <svg
        class="filePage"
        width="88"
        height="99"
        viewBox="0 0 88 99"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="88" height="99" fill="url(#paint0_linear_117_6)"></rect>
      <defs>
        <linearGradient
            id="paint0_linear_117_6"
            x1="0"
            y1="0"
            x2="81"
            y2="160.5"
            gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white"></stop>
          <stop offset="1" stop-color="#686868"></stop>
        </linearGradient>
      </defs>
    </svg>

    <svg
        class="fileFront"
        width="160"
        height="79"
        viewBox="0 0 160 79"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
      <path
          d="M0.29306 12.2478C0.133905 9.38186 2.41499 6.97059 5.28537 6.97059H30.419H58.1902C59.5751 6.97059 60.9288 6.55982 62.0802 5.79025L68.977 1.18034C70.1283 0.410771 71.482 0 72.8669 0H77H155.462C157.87 0 159.733 2.1129 159.43 4.50232L150.443 75.5023C150.19 77.5013 148.489 79 146.474 79H7.78403C5.66106 79 3.9079 77.3415 3.79019 75.2218L0.29306 12.2478Z"
          fill="url(#paint0_linear_117_5)"
      ></path>
      <defs>
        <linearGradient
            id="paint0_linear_117_5"
            x1="38.7619"
            y1="8.71323"
            x2="66.9106"
            y2="82.8317"
            gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C3BBFF"></stop>
          <stop offset="1" stop-color="#51469A"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
                  </button>


                </div>
              </div>

            </div>

          </div>
        </m-a>
      </div>

      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Form'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">فرم ها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="ui-checks"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['form'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'FormCreate'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>


      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Chats'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">چت ها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="chat-dots-fill"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['chat'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'ChatCreate'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Offer'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">کدتخفیف</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="receipt"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['offer'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'Offer'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Form'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">پاسخ های فرم</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="ui-checks-grid"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['form_fill'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'FormCreate'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <dashboard-slider1 class="radius-15 bg-secondary" slug="بنر-داشبورد-3"/>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Comments'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">کامنت ها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="chat-quote-fill"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['comment'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'Comments'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'PostsDashboard'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">پست ها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="newspaper"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['post'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'CreateContent'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'PagesDashboard'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">برگه ها</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="stickies"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['page'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'CreateContent'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
      <div class="col-lg-3 my-3">
        <m-a :href="{name:'Statistic'}">
          <div class="p-4 bg-secondary text-white shadow-sm radius-15">
            <div class="row">
              <div class="col-10 text-right">
                <h4 class="p-0 m-0">بازدید محصولات</h4>
              </div>
              <div class="col-2 text-left">
                <b-icon class="h2" icon="view-stacked"/>
              </div>
              <div class="col-9 text-right">
                <h4 v-if="!loading" class="p-0 m-0">{{ items['products_all_views'] }}</h4>
                <div class="" v-else>
                  <div class="loader"></div>
                </div>
              </div>
              <div class="col-3 text-left">
                <m-a :href="{name:'Statistic'}">
                  <h4 class="btn btn-primary">+</h4>
                </m-a>
              </div>
            </div>

          </div>
        </m-a>
      </div>
    </div>


  </div>
</template>

<script>
import DashboardSlider1 from "@/plugin/components/dashboard/DashboardSlider/DashboardSlider1.vue";
import DashboardMobileProfile from "@/plugin/components/dashboard/DashboardMobileProfile.vue";
import DashboardHeaderWidget from "@/plugin/components/dashboard/DashboardHeaderWidget.vue";

export default {
  name: "DashboardWidget1",
  components: {DashboardHeaderWidget, DashboardMobileProfile, DashboardSlider1},
  props: {
    cardLink: {
      default: ""
    },
    newItemLink: {
      default: ""
    }
  },
  data() {
    return {
      items: [],
      loading: true
    }
  },
  methods: {
    async getData() {
      this.items = await this.$store.dispatch('DashboardResource/getResources')
      this.items = this.items.data.data
      this.loading = false
    }
  },
  async mounted() {
    await this.getData()
  }
}
</script>

<style scoped>

.loader {
  width: 45px;
  height: 20px;
  background: linear-gradient(#0000 calc(1 * 100% / 6), #fff 0 calc(3 * 100% / 6), #0000 0),
  linear-gradient(#0000 calc(2 * 100% / 6), #fff 0 calc(4 * 100% / 6), #0000 0),
  linear-gradient(#0000 calc(3 * 100% / 6), #fff 0 calc(5 * 100% / 6), #0000 0);
  background-size: 10px 400%;
  background-repeat: no-repeat;
  animation: matrix 1s infinite linear;
}

@keyframes matrix {
  0% {
    background-position: 0% 100%, 50% 100%, 100% 100%
  }

  100% {
    background-position: 0% 0%, 50% 0%, 100% 0%
  }
}


.Documents-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 174px;
  border: none;
  padding: 0px 15px;
  border-radius: 5px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.folderContainer {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
}

.fileBack {
  z-index: 1;
  width: 80%;
  height: auto;
}

.filePage {
  width: 50%;
  height: auto;
  position: absolute;
  z-index: 2;
  transition: all 0.3s ease-out;
}

.fileFront {
  width: 85%;
  height: auto;
  position: absolute;
  z-index: 3;
  opacity: 0.95;
  transform-origin: bottom;
  transition: all 0.3s ease-out;
}

.Documents-btn:hover .filePage {
  transform: translateY(-5px);
}

.Documents-btn:active {
  transform: scale(0.95);
}

.Documents-btn:hover .fileFront {
  transform: rotateX(30deg);
}



.bg-secondary {
  transition: .5s ease-in-out all;
}

.bg-secondary:hover {
  background: #272325 !important;
  transition: .3s ease-in-out all;
  border: none !important;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px !important;
}

</style>